import { render, staticRenderFns } from "./NoteChat.vue?vue&type=template&id=7b6c5a70&scoped=true&lang=html&"
import script from "./NoteChat.vue?vue&type=script&lang=js&"
export * from "./NoteChat.vue?vue&type=script&lang=js&"
import style0 from "./NoteChat.vue?vue&type=style&index=0&id=7b6c5a70&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6c5a70",
  null
  
)

export default component.exports